import React from 'react';
import {
  Box,
  Card,
  CardContent,
  CardHeader,
  Avatar,
  Typography,
  Chip,
  Button,
} from '@mui/material';
import {
  PersonOutline,
  EmailOutlined,
  PhoneOutlined,
  BusinessOutlined,
  LogoutOutlined,
} from '@mui/icons-material';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { Logout, reset } from '../../../fitur/AuthSlice';

const ProfileRetail = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const user = useSelector((state) => state.auth.user);

  const handleLogout = () => {
    dispatch(reset());
    dispatch(Logout());
    navigate('/');
  };

  const bs3 = {
    panelDefault: {
      border: '1px solid #ddd',
      borderRadius: '4px',
      boxShadow: 'none',
      mb: 2,
      bgcolor: '#fff',
    },
    panelHeading: (color = '#f5f5f5', textColor = '#333') => ({
      bgcolor: color,
      color: textColor,
      px: 2,
      py: 1.2,
      borderBottom: '1px solid #ddd',
      borderRadius: '4px 4px 0 0',
      fontWeight: 700,
      fontSize: '14px',
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
    }),
    btnDanger: {
      bgcolor: '#d9534f',
      color: '#fff',
      border: '1px solid #d43f3a',
      borderRadius: '4px',
      px: 2,
      py: 0.8,
      fontSize: '13px',
      fontWeight: 400,
      textTransform: 'none',
      fontFamily: '"Helvetica Neue", Helvetica, Arial, sans-serif',
      '&:hover': { bgcolor: '#c9302c', borderColor: '#ac2925' },
    },
  };

  return (
    <Box sx={{ p: { xs: 1, md: 1.5 }, maxWidth: 600, mx: 'auto' }}>
      <Card variant="outlined" sx={{ ...bs3.panelDefault }}>
        <CardHeader
          title="Profil Pengguna"
          titleTypographyProps={{ variant: 'subtitle1', fontWeight: 600 }}
          sx={{ pb: 1 }}
        />

        <CardContent sx={{ pt: 0 }}>
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 2, mb: 3 }}>
            <Avatar
              sx={{
                width: 64,
                height: 64,
                bgcolor: '#337ab7',
                color: '#fff',
                fontWeight: 700,
                fontSize: '24px',
              }}
            >
              {(user?.nama || user?.username || 'U').charAt(0).toUpperCase()}
            </Avatar>
            <Box>
              <Typography variant="h6" fontWeight={700}>
                {user?.nama || user?.username || '-'}
              </Typography>
              <Chip
                label={user?.role || 'Staff Retail'}
                size="small"
                sx={{ mt: 0.5 }}
              />
            </Box>
          </Box>

          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PersonOutline sx={{ color: '#666' }} />
              <Typography>Nama: {user?.nama || user?.username || '-'}</Typography>
            </Box>

            {/* <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <EmailOutlined sx={{ color: '#666' }} />
              <Typography>Email: {user?.email || '-'}</Typography>
            </Box>

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PhoneOutlined sx={{ color: '#666' }} />
              <Typography>Telepon: {user?.telepon || user?.phone || '-'}</Typography>
            </Box> */}

            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <BusinessOutlined sx={{ color: '#666' }} />
              <Typography>Cabang: {user?.cabang?.namacabang || '-'}</Typography>
            </Box>
          </Box>

          <Box sx={{ mt: 3, pt: 2, borderTop: '1px solid #eee' }}>
            <Button
              variant="contained"
              color="error"
              onClick={handleLogout}
              startIcon={<LogoutOutlined />}
              sx={{ textTransform: 'none' }}
            >
              Logout
            </Button>
          </Box>
        </CardContent>
      </Card>
    </Box>
  );
};

export default ProfileRetail;